module.exports = "/images/icon_feather_book_open.svg?70a7830b647b86fca1a4de9ac9606db1";